/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

export const HomePrivateDashboard = () => {
  return (
    <section className="bg-white dark:bg-gray-900 rounded-lg">
      <div className="grid max-w-screen-xl px-4 py-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-12">
        <div className="mr-auto place-self-center lg:col-span-7">
          <p>Dashboard</p>
        </div>
      </div>
    </section>
  );
};
